import {
  getFromSS,
  saveToSS,
  SelectInput,
} from "@visiblethread/react-components";
import { confirmTypeSpecificFieldsReset } from "components/Modal/confModalTypes";
import { TYPE_SELECTOR_OPTIONS } from "constants/opportunities";
import { modalTypes } from "constants/types";
import { hasAnyTypeSpecificFieldFilled } from "pages/capture/TrackedOpportunities/helpers";
import { func, object } from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import {
  selectOpportunity,
  selectOppType,
} from "slices/opportunity/summary/selectors";
import { setOppType } from "slices/opportunity/summary/summarySlice";

import classes from "./TypeSelector.module.scss";

const SS_KEY = "manualOpportunityType";

const TypeSelector = ({ formData, resetTypeSpecificFields }) => {
  const dispatch = useDispatch();
  const oppType = useSelector(selectOppType);
  const opp = useSelector(selectOpportunity);
  const sessionOppType = getFromSS(SS_KEY);

  useEffect(() => {
    if (sessionOppType && sessionOppType !== oppType) {
      dispatch(setOppType(sessionOppType));
    }
  }, []);

  // Set opp type for already existiong opp
  useEffect(() => {
    const isExistiongOpp = Boolean(opp);
    if (isExistiongOpp) {
      dispatch(setOppType(opp?.opportunityType));
    }
  }, [opp]);

  const changeType = (option, clearTypeSpecificFields = false) => {
    dispatch(setOppType(option));
    saveToSS(SS_KEY, option);

    if (clearTypeSpecificFields) {
      resetTypeSpecificFields();
    }
  };

  const onChange = (option) => {
    if (hasAnyTypeSpecificFieldFilled(formData)) {
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          confirmTypeSpecificFieldsReset(
            () => changeType(option, true),
            dispatch
          )
        )
      );
    } else {
      changeType(option);
    }
  };

  return (
    <div className={classes.type_selector}>
      <label
        className={classes.type_selector__label}
        htmlFor="opportunity_type_selector"
      >
        Opportunity Type *
      </label>
      <div>
        <SelectInput
          options={TYPE_SELECTOR_OPTIONS}
          onChange={onChange}
          value={oppType || ""}
          placeholder="Select Opportunity Type"
          id="opportunity_type_selector"
        />
      </div>
    </div>
  );
};

TypeSelector.propTypes = {
  formData: object,
  resetTypeSpecificFields: func,
};

export default TypeSelector;
